/* eslint-disable camelcase */
import React, { useState } from 'react';
import axios from 'axios';
import { Flex, Switch } from 'antd';
import { OnboardingRocketIcon } from 'components/cwo-icons';
import { bool, shape, string } from 'prop-types';
import { dont_show_again_path } from 'js-routes/generated/routes';

/**
 * "Onboarding" row of the support (?) menu: a switch that hides or brings
 * back the Get Started widget. The page reloads after toggling so the
 * monitoring center reflects the new state immediately.
 */
const OnboardingToggle = ({ item }) => {
  const [enabled, setEnabled] = useState(item.enabled);
  const [saving, setSaving] = useState(false);

  const toggle = async (checked) => {
    setSaving(true);
    setEnabled(checked);

    try {
      await axios.get(dont_show_again_path({
        dont_show_subject: 'dont_show_get_started',
        dont_show_value: !checked,
      }));
      location.reload();
    } catch {
      setEnabled(!checked);
      setSaving(false);
    }
  };

  return (
    <Flex
      align="center"
      justify="space-between"
      gap={8}
      className="navigation-top-menu__link"
    >
      <Flex align="center" gap={8}>
        <OnboardingRocketIcon />
        <span>{item.label}</span>
      </Flex>
      <Switch size="small" checked={enabled} loading={saving} onChange={toggle} />
    </Flex>
  );
};

OnboardingToggle.propTypes = {
  item: shape({
    label: string.isRequired,
    enabled: bool.isRequired,
  }).isRequired,
};

export default OnboardingToggle;
